import React from "react";
import {
	IonImg,
	IonLabel,
	IonCol,
	IonRow,
	IonText,
	IonSlides,
	IonSlide,
	IonContent,
} from "@ionic/react";
import { DISCOUNT, FLAT, USE_CODE, VALID, LEARN_MORE } from "../../constants";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { checkMediaQuery } from "../../utils";

export const DisCountSliders: React.FC = (props: any) => {
	const [load, setLoad] = React.useState(false);
	const sliderRef = React.useRef<HTMLIonSlidesElement>(null);
	const { flatDisCountSlides } = props;
	let timeout: any;

	React.useEffect(() => {
		updateIonSlides();

		console.log("flatDisCountSlides 1...", flatDisCountSlides);
		return () => {
			clearTimeout(timeout);
		};
	}, [sliderRef, flatDisCountSlides.length]);

	const updateIonSlides = () => {
		if (sliderRef !== null) {
			timeout = setTimeout(() => sliderRef.current?.update(), 500);
			sliderRef.current
				?.getSwiper()
				.then((swiper: any) => {
					swiper.params.pagination.el = ".swiper-pagination";
					swiper.pagination.init();
					swiper.pagination.render();
					swiper.pagination.update();
					swiper.update();
				})
				.catch((err: any) => {});
		}
	};

	const paginationProps = {
		el: ".swiper-pagination",
		type: "bullets",
		clickable: true,
		bulletElement: "span",
		bulletClass: "swiper-pagination-bullet",
		bulletActiveClass: "swiper-pagination-bullet-active",
		renderBullet: function (index: any, className: any) {
			return '<span class="swiper-pagination-bullet">' + "</span>";
		},
	};
	const sliderOptions = checkMediaQuery()
		? { loop: false, autoplay: false, spaceBetween: 15, scrollBar: false }
		: {
				loop: true,
				autoplay: false,
				spaceBetween: 15,
				scrollBar: false,
				pagination: paginationProps,
		  };

	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"June",
		"July",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];
	return (
		<>
			{flatDisCountSlides.length && (
				<IonSlides
					id="Discount-sliders"
					ref={sliderRef}
					pager={true}
					options={sliderOptions}
					key={flatDisCountSlides
						.map((ele: any, index: any) => {
							if (Object.keys(ele).includes("articleId")) {
								return ele.articleId;
							} else return ele.offerId;
						})
						.join(",")}
					className="slide_parent"
					onIonSlidesDidLoad={() => setLoad(true)}
					// onIonSlideDrag={async (event: any) => {
					//   console.log(await event.target.getActiveIndex(), "fjkasdjhf");
					//   if (!checkMediaQuery()) updateIonSlides();
					// }}
					// onIonSlideWillChange={() => updateIonSlides()}
				>
					{flatDisCountSlides.map((ele: any, index: any) => (
						<IonSlide
							className="slide_margin_bottom"
							style={{
								background: ele.offerId
									? `linear-gradient(93.91deg, ${ele.displayColor} 1.09%, #231b05 64.95%)`
									: ele.displayColor,
							}}
							key={index}
						>
							{ele.offerId ? (
								<IonRow
									key={index}
									className="discount_row minHeight260_165"
									onClick={() =>
										props.history.push({
											pathname: "/portal/offer-details",
											state: { offerDetails: ele },
										})
									}
								>
									{!!ele.name && (
										<>
											<IonCol className="vocher_code" size-md="6" size="7">
												<div className="discount_div discount_web">
													{ele.name.split(" ").map((name: any, index: any) => (
														<IonLabel
															className={
																index === 1 ? "discount_value" : "discount_percentage"
															}
															key={index}
															color="secondary"
														>
															{index === 2 ? "Discount" : name}
														</IonLabel>
													))}
												</div>

												<div className="border_code border_code_web dashboard_border transColor">
													<IonLabel className="year year_web">{USE_CODE}</IonLabel>
													<IonLabel className="year off_code">{ele.offerCode}</IonLabel>
												</div>
												<div className="discount_date dashboard_date">
													<IonLabel>
														{VALID}
														{new Date(ele.validity.endDate).getDate()}{" "}
														{months[new Date(ele.validity.endDate).getMonth()]}{" "}
														{new Date(ele.validity.endDate).getFullYear()}
													</IonLabel>
												</div>
											</IonCol>
											<IonCol size-md="6" size="5" className="img_web">
												<div className="img_scroll">
													<IonImg src={ele.imageUrl} className="discount_slides" />
												</div>
											</IonCol>
										</>
									)}
									{!ele.name && (
										<IonCol size-md="12" size="12">
											<div className="img_scroll">
												<IonImg src={ele.imageUrl} />
											</div>
										</IonCol>
									)}
								</IonRow>
							) : (
								<IonRow
									className="dashb_art_slide"
									onClick={() => {
										const target = "_blank";
										const options =
											"location=no,clearcache=yes,hideurlbar=yes,hidenavigationbuttons=yes,cleardata=yes,toolbarposition=top";
										// InAppBrowser.create(ele.webpageUrl, target, options);
										window.open(ele.webpageUrl, target, options);
									}}
								>
									<div className="dashb_ar_title_parent">
										<IonLabel className="dashb_art_title">{ele.title}</IonLabel>
									</div>
									<IonLabel className="dashb_art_shrdes">{ele.shortDescription}</IonLabel>
									<div className="details_article">
										<IonLabel color="light">{LEARN_MORE} </IonLabel>
										<IonImg
											src="/images/right_arrow_circle.svg"
											className="dashb_cir_arrow"
										/>
									</div>
								</IonRow>
							)}
						</IonSlide>
					))}
				</IonSlides>
			)}
		</>
	);
};
